import React, { useContext, useEffect, useState } from "react";
import { withRouter } from "react-router-dom";
import styled from "styled-components";
import CircularProgress from "@material-ui/core/CircularProgress";
import Icon from "@material-ui/core/Icon";
import { shareMealsMultiple, getMealSharing } from "../../../../api";
import { AuthContext } from "../../../../auth-context";
import Button from "../../../../components/button";
import { MealListItem } from "../templates/components/meal-list-item";

const MealShareContainer = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 64px 32px;
`;

const PageTitle = styled.h2`
  margin: 0 auto 30px auto;
  color: #555;
  font-family: "DM Sans", sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
`;

const TableContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 0px 8px 0px #e1e2e6;
  margin: 0 auto;
`;

const Table = styled.table`
  background: #fff;
  border-spacing: 0px;
  width: 100%;
`;

const TableHead = styled.thead`
  color: #fff;
`;

const TableBody = styled.tbody``;

const TableHeadRow = styled.tr``;

const TableBodyRow = styled.tr`
  &:hover {
    background: #f2f2f2;
  }
`;

const HeadCell = styled.th`
  background: #070c29 !important;
  font-family: ${(props) => props.theme.font.primary};
  font-size: 1rem;
  font-weight: 500;
  letter-spacing: 1px;
  min-width: ${(props) => (props.bigWidth ? "160px" : "100px")};
  padding: 8px;
  position: sticky;
  top: 0;
  z-index: 30;
`;

const DataCell = styled.td`
  border-bottom: 1px solid #e8e8e8;
  font-family: ${(props) =>
    props.number ? props.theme.font.primary : props.theme.font.secondary};
  padding: 4px;
  text-align: center;
  cursor: pointer;
`;

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;

  @media (max-width: 900px) {
    margin-top: 16px;
  }
`;

const AddButton = styled(Button)`
  margin: 0;
  margin-right: 16px;
  min-width: 180px;
`;

const MealShare = (props) => {
  const mealIdStr = props.match.params.id;
  const { user } = useContext(AuthContext);
  const [name, updateName] = useState(null);
  const [foods, updateFoods] = useState(null);
  const [notes, updateNotes] = useState(null);
  const [sharing, updateSharing] = useState([]);
  const [mealStatus, updateMealStatus] = useState(0);
  const [checkAll, updateCheckAll] = useState(false);
  const [saving, updateSaving] = useState(false);
  const [meal, setMeal] = useState("");

  useEffect(() => {
    if (mealStatus === 0) {
      updateMealStatus(1);
      getMealSharing(user.id, mealIdStr).then((res) => {
        setMeal(res.data);
        updateName(res.data.name);
        updateFoods(res.data.foods);
        updateNotes(res.data.notes);
        // updateSharing(res.data.sharing.map((s) => s.friend_id));
        updateMealStatus(2);
      });
    }
  }, [mealIdStr, mealStatus, user.id]);

  const renderFoods = (foods) => {
    let foodList = "";

    for (let n = 0; n < foods.length; ++n) {
      foodList += ", " + foods[n].name;
      if (n + 1 < foods.length && foodList.length > 50) {
        foodList += ", ...";
        break;
      }
    }
    if (foodList.length !== 0) {
      foodList = foodList.slice(2);
    }
    return foodList;
  };

  const handleCheckAllClick = () => {
    let newSharing;
    let newCheckAll;
    if (checkAll) {
      newSharing = [];
      newCheckAll = false;
    } else {
      newSharing = user.accounts
        .filter(
          (a) =>
            a.user_id !== null &&
            (a.manager_id === user.id || a.trainers.includes(user.id)) &&
            a.trainer_permission === 1
        )
        .map((a, index) => a.user_id);
      newCheckAll = true;
    }
    updateSharing(newSharing);
    updateCheckAll(newCheckAll);
  };

  const handleCheckboxClick = (user_id) => {
    let newSharing = sharing.slice(0);
    const index = newSharing.findIndex((s) => s === user_id);
    if (index === -1) {
      newSharing.push(user_id);
    } else {
      newSharing.splice(index, 1);
    }
    updateSharing(newSharing);
  };

  const handleSubmit = () => {
    if (!saving) {
      updateSaving(true);
      shareMealsMultiple(user.id, [Number(mealIdStr)], sharing).then((res) => {
        updateSaving(false);
        window.localStorage.setItem(
          "pendingSnackbar",
          "The meal template was successfully shared."
        );
        props.history.push("/dashboard/templates");
      });
    }
  };

  const handleCancel = () => {
    props.history.push("/dashboard/templates");
  };

  const renderView = () => {
    if (mealStatus !== 2) {
      return <CircularProgress size={32} />;
    } else if (foods === null) {
      return <p>The day with id {mealIdStr} was not found.</p>;
    } else {
      return (
        <>
          <PageTitle>Share Meal Template</PageTitle>
          <MealListItem
            meal={meal}
          />
          <div style={{ margin: "20px 0 10px 0" }}>
            <label>
              Select the clients who should receive this meal template.
            </label>
          </div>
          <TableContainer>
            <Table>
              <TableHead>
                <TableHeadRow>
                  <HeadCell>
                    <Icon
                      className="material-icons"
                      onClick={() => handleCheckAllClick()}
                      style={{ color: checkAll ? "#14ab40" : "#5a5a5a" }}
                    >
                      {checkAll ? "check_circle" : "radio_button_unchecked"}
                    </Icon>
                  </HeadCell>
                  <HeadCell></HeadCell>
                </TableHeadRow>
              </TableHead>
              <TableBody>
                {user.accounts
                  .filter(
                    (a) =>
                      a.user_id !== null &&
                      (a.manager_id === user.id ||
                        a.trainers.includes(user.id)) &&
                      a.trainer_permission === 1
                  )
                  .map((a, index) => (
                    <TableBodyRow key={index}>
                      <DataCell>
                        <Icon
                          className="material-icons"
                          onClick={() => handleCheckboxClick(a.user_id)}
                          style={{
                            color: sharing.includes(a.user_id)
                              ? "#14ab40"
                              : "#5a5a5a",
                          }}
                        >
                          {sharing.includes(a.user_id)
                            ? "check_circle"
                            : "radio_button_unchecked"}
                        </Icon>
                      </DataCell>
                      <DataCell>{a.name}</DataCell>
                    </TableBodyRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
          <ButtonContainer>
            <AddButton
              label="Submit"
              onClick={handleSubmit}
              disabled={sharing.length === 0}
              isLoading={saving}
            />
            <AddButton label="Cancel" onClick={handleCancel} />
          </ButtonContainer>
        </>
      );
    }
  };

  return (
    <>
      <MealShareContainer>{renderView()}</MealShareContainer>
    </>
  );
};

export default withRouter(MealShare);
